module.exports = __webpack_public_path__ + "static/media/cert_144.5e96c478.jpg";